import { render, staticRenderFns } from "./ContenitoriCristal.vue?vue&type=template&id=b6af3dac&scoped=true&"
import script from "./ContenitoriCristal.vue?vue&type=script&lang=js&"
export * from "./ContenitoriCristal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6af3dac",
  null
  
)

export default component.exports